// --- React
import React, { useMemo } from 'react';
// --- Utilities
import { getLoadDetails } from '../utils/getDetailsData';
// --- Components
import { FieldRow } from '../../components';
// --- Styles
import '../../styles.scss';

/**
 * LoadCard
 *
 * Features:
 * - Displays load details in tap-ui style (horizontal label-value)
 * - Supports search/filter functionality
 *
 * @param {object} details - Product details object
 * @param {string} searchTerm - Optional search term to filter fields
 * @returns {Element}
 */
export function LoadCard({ details, searchTerm = '' }) {
    // Function to extract load details from the provided data
    const loadDetails = useMemo(() => getLoadDetails(details), [details]);

    // Filter fields based on search term
    const filteredFields = useMemo(() => {
        if (!searchTerm.trim()) return loadDetails;

        const term = searchTerm.toLowerCase();
        return loadDetails.filter(
            (field) =>
                field.label.toLowerCase().includes(term) ||
                String(field.value || '').toLowerCase().includes(term)
        );
    }, [loadDetails, searchTerm]);

    if (filteredFields.length === 0 && searchTerm.trim()) {
        return (
            <div className="no-results">
                <i className="fa-solid fa-search" />
                <p>No fields match your search.</p>
            </div>
        );
    }

    return (
        <div className="load-card">
            <div className="detail-section-content">
                {filteredFields.map(({ label, value }, idx) => (
                    <FieldRow
                        key={`load-detail-${idx}`}
                        label={label}
                        value={value}
                        noBorder={idx === filteredFields.length - 1}
                    />
                ))}
            </div>
        </div>
    );
}
